<template>
  <el-dialog
    :visible="visible"
    :close-on-click-modal="false"
    :before-close="close"
    :modal-append-to-body="false"
    width="600px"
    center
    :title="$t('Audience_Segment_Enable_Dialog_Title')"
  >
    <div class="enable-dialog-content">
      <p>
        {{
          $t('Audience_Segment_Enable_Dialog_Message', { title: segment.title })
        }}
      </p>
      <el-checkbox
        v-model="fullSync"
        data-qa="enable-segment-full-sync-checkbox"
      >
        {{ $t('Audience_Segment_Enable_Dialog_FullSync') }}
      </el-checkbox>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close" data-qa="enable-segment-cancel-button">
        {{ $t('Button_Cancel') }}
      </el-button>
      <el-button
        type="primary"
        @click="confirm"
        data-qa="enable-segment-confirm-button"
      >
        {{ $t('Audience_Segment_Enable_Dialog_Button') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'EnableRollingSegmentDialog',

  props: {
    segment: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      fullSync: true
    }
  },

  methods: {
    close() {
      this.$emit('close')
    },

    confirm() {
      this.$emit('enable', { full_sync: this.fullSync })
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.fullSync = true
      }
    }
  }
}
</script>

<style scoped>
.enable-dialog-content {
  text-align: center;
}

.enable-dialog-content p {
  font-size: 16px;
  margin-bottom: 16px;
  word-break: keep-all;
}
</style>



// WEBPACK FOOTER //
// src/modules/audiences/components/EnableRollingSegmentDialog.vue